<template>
  <div :class="align" class="title-main">
    <h4 class="primary-title_ text-uppercase text-h4 font-weight-bold mb-2">
      <slot/>
    </h4>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../assets/styles';
@import './title-style';
</style>

<script>
export default {
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
}
</script>
